import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Loading } from '../pages/loading/loading';
import NotFound from '../pages/NotFound';
import { useValidateReportId } from '../requests/reports';
import { whiteListedReports } from './ProtectedContent';

const getReportTypeByUrlPath = (pathName: string) => {
    return /overwatch/.test(pathName) ? 'overwatch' : /pathfinder/.test(pathName) ? 'pathfinder' : 'story';
};

export const ReportContent: React.FC = () => {
    const location = useLocation();
    const params = useParams();
    const pathName = location.pathname;
    const reportTypeUrlString = getReportTypeByUrlPath(pathName);
    const isWhitelisted: boolean = params.id !== undefined && whiteListedReports.includes(params.id);
    const validationNeeded = !isWhitelisted;

    const { data: isValid, isLoading } = useValidateReportId(params, reportTypeUrlString, validationNeeded);

    if (validationNeeded && isLoading) {
        return <Loading></Loading>;
    }

    if (validationNeeded && (!params.id || !isValid)) {
        return <NotFound location={window.location.href} />;
    }

    return <Outlet />;
};
